import { Inject } from '@odinjs/odin';
import { AutocompleteAPI, FieldAPI, FormAPI, PanelAPI } from '@philips-internal/oswald-ui-components';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnBeforeCancel, OnBeforeSubmit, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import moment from 'moment';
import { BloodManagementReverseAliases, FragmentNames } from '../../../../../codegen';
import { ISO_FULL_DATE_FORMAT } from '../../../../../constants/date-utils';
import { Endpoint } from '../../../../../constants/endpoints';
import { ApplicationRoute } from '../../../../../constants/routes';
import BaseController from '../../../../../controllers/BaseController';
import InformationBarUtils from '../../../../commons/header/information-bar-header-utils';
import MedicationService from '../../../services/medication-service';
import { ReasonType } from '../../adult-tpn/adult-tpn-types';

@Controller({ component: BloodManagementReverseAliases.BLOOD_MANAGEMENT_REVERSE_LAYOUT, fragment: FragmentNames.BLOOD_MANAGEMENT_REVERSE })
export default class BloodManagementReverseController extends BaseController {

  @Inject(BloodManagementReverseAliases.FORM_REASON)
  private formApi!: FormAPI;

  @Inject(BloodManagementReverseAliases.PANEL_LOADER)
  private feedbackPanelLoaderApi!: PanelAPI;

  @Inject(BloodManagementReverseAliases.AUTOCOMPLETE_REASON_LIST)
  private reasonAutocompleteApi!: AutocompleteAPI;

  @Inject(BloodManagementReverseAliases.NOTES_FIELD)
  private notesFieldApi!: FieldAPI;

  @OnMount(BloodManagementReverseAliases.BLOOD_MANAGEMENT_REVERSE_LAYOUT)
  handleMountLayout(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    this.context.set({ encounterId, patientId });
    InformationBarUtils.collapsedBar = true;
  }

  @OnBeforeCancel(BloodManagementReverseAliases.FORM_REASON)
  handleCancelForm(): void {
    applicationContext.popNavigationItem();
  }

  @OnBeforeSubmit(BloodManagementReverseAliases.FORM_REASON)
  handleSubmitForm(): void {
    this.reverse();
  }

  private reverse(): void {
    this.feedbackPanelLoaderApi.setVisible(true);
    const reasonSelected = this.reasonAutocompleteApi.getValue() as unknown as ReasonType;
    const {
      encounterId,
      prescriptionNumber,
      sequenceNumber
    } = this.historyService.getCurrentRouteParams();
    const situationSolutionType = 3

    const body = {
      dateHour: moment().format(ISO_FULL_DATE_FORMAT),
      encounterNumber: Number(encounterId),
      justificationDescription: this.notesFieldApi.getValue(),
      prescriptionNumber: Number(prescriptionNumber),
      reasonSequenceNumber: reasonSelected.sequenceNumber,
      situationSolutionType,
      solutionNumber: sequenceNumber
    } as Record<string, Value>;

    HttpService.post(Endpoint.REVERSE_LAST_EVENT, {}, { body })
      .then(() => {
        MedicationService.showToast(MessageService.translate('text.revert-event'), ToastLevel.SUCCESS)
        this.goToTimeline()
      })
      .catch((error) => {
        const message = error.body.messageDescription;
        const errorMessage = error.body.errors.join('; ')
        MedicationService.showToast(message ?? errorMessage, ToastLevel.ERROR)
      }).finally(() => {
        this.formApi.setLocked(true);
      });
  }

  private goToTimeline(): void {
    const { patientId, encounterId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(ApplicationRoute.ADEP_ELETRONIC_SERVICE_PERSONAL_INFORMATION, {
      encounterId,
      patientId,
    });
    applicationContext.clearNavigationStack();
  }
}